export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'sdui.app', 'iam.sdui-group.app'],
      appName: 'TOLL Pflege',
      packageName: 'com.sdui.toll',
      defaultUrl: 'https://sdui.app',
      android: {
        flavor: 'toll'
      },
      ios: {
        Scheme: 'TOLL'
      }
    }
  }
}
